// extracted by mini-css-extract-plugin
module.exports = {"overlay":"styles-module--overlay--rEajZ","reveal":"styles-module--reveal--sqaDd"};